<template>
  <div>
    <div
      v-for="child in children"
      :key="resolvePath(child.path)"
    >
      <template>
        <router-link
          v-if="!child.children"
          :to="resolvePath(child.path)"
        >
          <el-menu-item
            :index="resolvePath(child.path)"
            :class="{'el-menu-item-active': judgeRoute(child)}"
          >
            <span
              v-if="child.meta.title"
              slot="title"
              class="sidebar-title"
              :class="{'sidebar-title-active': judgeRoute(child)}"
            >
              {{ child.meta.title }}
            </span>
          </el-menu-item>
        </router-link>
        <!--渲染子菜单-->
        <el-submenu
          v-else
          :index="resolvePath(child.path)"
          popper-append-to-body
        >
          <template slot="title">
            <span
              v-if="child.meta.title"
              slot="title"
              class="sidebar-title"
            >
              {{ child.meta.title }}
            </span>
          </template>
          <sidebar-item
            :item="child"
            :base-path="resolvePath(child.path)"
          />
        </el-submenu>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    required: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    children () {
      if (this.item.children) {
        return this.item.children.filter(item => !item.hidden)
      } else {
        return []
      }
    }
  },
  methods: {
    resolvePath (path) {
      return `${this.basePath}/${path}`
    },
    judgeRoute (route) {
      const path = `${this.basePath}/${route.path}`
      if (path === this.$route.path) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.el-menu-item{
  position: relative;
  width:180px;
}
.el-submenu .el-menu-item {
    min-width:180px !important;
}
.el-menu-item:hover{
  background:#E5F2FF !important;
  color:#E5F2FF
}

.el-submenu__title:hover{
  background:#E5F2FF !important;
  color: #E5F2FF;
}

.sidebar-title{
  font-size:14px;
  font-weight:400;
  color:rgba(51,51,51,1);
  user-select:none;
}

.el-menu-item-active{
  background:#E5F2FF!important;
  border-right:5px solid rgba(36,149,255,1)
}
.sidebar-title-active{
  color:rgba(36,149,255,1)!important;
}
</style>
